var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClothing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.333 15h9.334V6.229l2 .675L17 3.53 12.667 1H11c-.222 1.214-.889 1.822-2 1.822S7.222 2.214 7 1H5.333L1 3.53l1.333 3.374 2-.675V15z",
    stroke: "#376F66",
    fill: "none",
    fillRule: "evenodd"
  })));
}
export default SvgIconClothing;